var resolve = require("./resolve");
var request = require("./request");
var Promise = require("bluebird");
var config = require("./config");

exports.GetPaymentFile = function (paymentIds) {
  var params = "";
  paymentIds.forEach(function (i) {
      if (params.length > 0) {
          params = params + "&";
      }
      params = params + "paymentIds=" + i;
  });
  return request.get(resolve(config.url(), 'payments/file?' + params)).promise();
}

exports.UpdatePaymentDate = function(id, date){
    var req = {
        ExpectedPaymentDate: date
    }
    return request.put(resolve(config.url(), "payments/expectedPaymentDate/" + id), req).promise();
}

exports.SplitPayment = function(id, payments){
    var req = {
        Payments: payments
    }
    return request.post(resolve(config.url(), "payments/split/" + id), req).promise();
}
